// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"src-components-Modal----modalFull-module---modalContainer---31CyW","centerBlock":"src-components-Modal----modalFull-module---centerBlock---2kR7v","modalCloseIcon":"src-components-Modal----modalFull-module---modalCloseIcon---3z9pV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/modalFull.module.scss
// module id = 1149
// module chunks = 168707334958949